import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { brand } from '../theme';

export default function FeatureCard({ icon: Icon, title, description, accent = 'blue', variant = 'light' }) {
  const isDark = variant === 'dark';
  const accentColor = accent === 'gold' ? brand.gold : brand.blue;
  const iconColor = isDark ? brand.amberAccent : accentColor;

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 3, md: 3.5 },
        height: '100%',
        borderRadius: 3,
        position: 'relative',
        overflow: 'hidden',
        transition: 'transform .2s ease, box-shadow .2s ease, border-color .2s ease',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        ...(isDark
          ? {
              bgcolor: brand.navy,
              color: '#fff',
              border: '1px solid rgba(255,255,255,0.12)',
              '&:hover': {
                transform: 'translateY(-3px)',
                borderColor: 'rgba(255,255,255,0.22)',
                boxShadow: '0 18px 40px -22px rgba(0,0,0,0.45)',
              },
            }
          : {
              border: `1px solid ${brand.border}`,
              '&:hover': {
                transform: 'translateY(-3px)',
                borderColor: 'rgba(30,91,255,0.35)',
                boxShadow: '0 18px 40px -22px rgba(15,23,42,0.25)',
              },
            }),
      }}
    >
      {isDark && (
        <Box
          aria-hidden
          sx={{
            position: 'absolute',
            inset: 0,
            background: brand.ctaPanelGradient,
            pointerEvents: 'none',
          }}
        />
      )}
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 2,
          height: '100%',
        }}
      >
        {Icon && (
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: 2,
              border: `2px solid ${brand.blue}`,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              color: iconColor,
            }}
          >
            <Icon fontSize="medium" />
          </Box>
        )}
        <Typography variant="h5" sx={{ fontWeight: 700, fontSize: '1.2rem', color: isDark ? '#fff' : brand.navy }}>
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: isDark ? '#fff' : brand.slate,
            fontSize: '0.98rem',
            lineHeight: 1.6,
          }}
        >
          {description}
        </Typography>
      </Box>
    </Paper>
  );
}
